import { Box, Button, Dialog, Theme, Typography } from '@mui/material'
import React, { useState } from 'react'
import OTPForm from '../../lib/formik/OtpForm'
import { useHistory, useRouteMatch } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { bseGenOtpRes, resendBSEValidateOtp, submitBSEValidateOtp, submitBSEValidateOtpRes } from '../../redux-store/actions/bank';
import { SuccessIcon } from '../../assets/SvgIcons';
import { USER_ROLES } from '../../utils/constant';
import { RootStateType } from '../../redux-store/reducers';
import { showError } from '../../redux-store/actions/auth';
import { is } from 'date-fns/locale';

export default function VerifyAddBankOtp(): JSX.Element {
    const { url } = useRouteMatch();
    const history = useHistory();
    const { cartId, id, message, isBSEEnabled, numberOfOTPTries } = history.location.state as unknown as { cartId: string, id: string, message: string, isBSEEnabled: boolean, numberOfOTPTries: number };
    const [otpMessage, setOtpMessage] = useState<string>(message ?? '');
    const [numberOfOtpTries,setNumberOfOtpTries] = useState<number>(numberOfOTPTries ?? 0)
    const dispatch = useDispatch();
    const [submitBSEPopup, setSubmitBSEPopup] = useState<boolean>(false);
    const [submitMPowerPopup, setSubmitMPowerPopup] = useState<boolean>(false);
    const { role = '' } = useSelector((store: RootStateType) => store.auth);
    const [validationErrPopup,setValidationErrPopup]  = useState<boolean>(false);
    const [validationErr,setValidationErr]  = useState<string>('');

    const handleSubmit = async (otp: string) => {
        const payload = {
            otp,
            portal: "",
            id,
            cartId,
            isBSEEnabled:isBSEEnabled??false
        }
        const validateRes = await (dispatch(submitBSEValidateOtp(payload)) as unknown as Promise<submitBSEValidateOtpRes>)
        if (!validateRes?.isSuccess && validateRes?.isBseFailed) {
            setValidationErrPopup(true);
            setValidationErr(validateRes?.message ?? "");
            return;
        }
        else if(!validateRes?.isSuccess){
            dispatch(showError(validateRes?.message ?? ""));
            return;
        }
        else if (validateRes?.isSuccess && validateRes?.isBSEEnabled) {
            setSubmitBSEPopup(true);
        }
        else if(validateRes?.isSuccess && !validateRes?.isBSEEnabled){
            setSubmitMPowerPopup(true);
        }


    };

    const handleResend = async () => {
        const payload = {
            cartId: cartId ?? "",
            id: id ? `${id}` : "",
            isBSEEnabled:isBSEEnabled??false
        }

        const response = await (dispatch(resendBSEValidateOtp(payload)) as unknown as Promise<bseGenOtpRes>)

        if (response?.isSuccess) {
            setOtpMessage(response?.message ?? "");
            setNumberOfOtpTries(response?.numberOfOTPTries ?? 0);
            history.replace({
                pathname: url,
                state: { id: response?.id ?? "", cartId: response?.cartId ?? "", message: response?.message ?? "", isBSEEnabled: response?.isBSEEnabled ?? false, numberOfOTPTries: response?.numberOfOTPTries }
            });
        }
    }


    const redirectDashboard = () => {
        if (role === USER_ROLES.RM) {
            history.replace('/dashboard');
        }
        else {
            history.replace('/investor-dashboard');
        }
    }
    return (
        <>
            <Box sx={{ padding: {xs:"10px 10px",sm:'30px 45px'} }}>
                <Typography
                    variant="h1"
                    sx={(theme: Theme) => ({
                        lineHeight: "32.5px",
                        color: theme.palette.text.primary
                    })}
                >
                    Add Bank Confirmation
                </Typography>
                <Box
                    sx={(theme: Theme) => ({
                        marginTop: "25px",
                        borderRadius: "20px",
                        backgroundColor: theme.palette.common.white,
                        padding: {xs:"10px",sm:"50px"},
                        boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    })}
                >
                    <Box sx={{ width: "50%" }}>
                        <OTPForm
                            onSubmit={handleSubmit}
                            onResend={handleResend}
                            otpMessage={otpMessage ?? ''}
                            warningMessage=""
                            numberOfTries={numberOfOtpTries}
                        />
                    </Box>
                </Box>
            </Box>
            <Dialog
                // onClose={() => setSubmitBSEPopup(false)}
                open={submitBSEPopup}
                maxWidth='sm'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "24px",
                        width: "533px",
                    },
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "48px"
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingTop: "15px",
                            rowGap: "12px"
                        }}
                    >
                        <SuccessIcon />
                        <Typography
                            variant="h2"
                            sx={(theme: Theme) => ({
                                lineHeight: "25px",
                                letterSpacing: "0.01px",
                                color: theme.palette.text.primary
                            })}
                        >
                            Submitted to BSE!
                        </Typography>
                        {/* <Typography
                            variant="subtitle_400"
                            sx={(theme: Theme) => ({
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.secondary,
                                textAlign: "center"
                            })}
                        >
                            {paymentFalseMessage}
                        </Typography> */}
                    </Box>
                    <Box>
                        <Button
                            variant="contained"
                            fullWidth
                            sx={(theme: Theme) => ({
                                borderRadius: "4px",
                                padding: "13px 20px",
                                backgroundColor: theme.palette.primary[500],
                                ...theme.typography.body_600,
                                fontSize: "16px",
                                lineHeight: "20px"
                            })}
                            onClick={redirectDashboard}
                        >
                            Go To Dashboard
                        </Button>
                    </Box>
                </Box>

            </Dialog>
            <Dialog
                // onClose={() => setSubmitBSEPopup(false)}
                open={submitMPowerPopup}
                maxWidth='sm'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "24px",
                        width: "533px",
                    },
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "48px"
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingTop: "15px",
                            rowGap: "12px"
                        }}
                    >
                        <SuccessIcon />
                        <Typography
                            variant="h2"
                            sx={(theme: Theme) => ({
                                lineHeight: "25px",
                                letterSpacing: "0.01px",
                                color: theme.palette.text.primary
                            })}
                        >
                            Submitted Successfully!
                        </Typography>
                        {/* <Typography
                            variant="subtitle_400"
                            sx={(theme: Theme) => ({
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.secondary,
                                textAlign: "center"
                            })}
                        >
                            {paymentFalseMessage}
                        </Typography> */}
                    </Box>
                    <Box>
                        <Button
                            variant="contained"
                            fullWidth
                            sx={(theme: Theme) => ({
                                borderRadius: "4px",
                                padding: "13px 20px",
                                backgroundColor: theme.palette.primary[500],
                                ...theme.typography.body_600,
                                fontSize: "16px",
                                lineHeight: "20px"
                            })}
                            onClick={redirectDashboard}
                        >
                            Go To Dashboard
                        </Button>
                    </Box>
                </Box>

            </Dialog>
            <Dialog
                // onClose={() => setValidationErrPopup(false)}
                open={validationErrPopup}
                maxWidth='sm'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "24px",
                        width: "533px",
                    },
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "48px"
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingTop: "15px",
                            rowGap: "12px"
                        }}
                    >
                    {validationErr}
                    </Box>
                    <Box>
                        <Button
                            variant="contained"
                            fullWidth
                            sx={(theme: Theme) => ({
                                borderRadius: "4px",
                                padding: "13px 20px",
                                backgroundColor: theme.palette.primary[500],
                                ...theme.typography.body_600,
                                fontSize: "16px",
                                lineHeight: "20px"
                            })}
                            onClick={()=>history.replace('/bank/updateBank')}
                        >
                            Go To Update Banks
                        </Button>
                    </Box>
                </Box>

            </Dialog>
        </>
    )
}
